import AbstractPageBaseController from '../../../core/abstracts/controllers/page-controller';

export default class ContactsDuplicatesPageController extends AbstractPageBaseController {

    constructor($scope, $injector) {
        super($scope, $injector);

        this.setupStore();
    }

    setupStore() {
        if (this.stateParams.store) {
            this.store = this.stateParams.store;
        } else {
            this.store = this.injector.get('ContactDuplicates').create(`ContactsDuplicatesView`);
            // if (this.store.state.visible.length <= 3) {
            //     this.store.commit('setVisible', [
            //         'contact.first_name',
            //         // 'contact.email'
            //     ]);
            // }
        }

        this.store.dispatch('loadState');
        this.store.commit('setTitle', 'Duplicates in Addressbook');
        this.store.commit('setVm', this);
        // this.store.commit('setPrefix', 'guestlists/' + this.guestlist.id);
        this.store.commit('setDataUrl', 'contacts/duplicates');

        this.store.dispatch('getDefinitions');

        this.store.resetGetters();
    }

    close() {
        this.mode = 'listview';
    }

    save() {
        const data = {
            fields: {rsvp: this.rsvp, contact: this.contact},
            items: this.store.getters.selectedFilters
        };
        // this.api.put(`rsvps`, data)
        //     .then(() => {
        //         this.alert.success('Bookings Update', 'The bookings details have successfully been updated');
        //         this.refresh().then(this.close.bind(this))
        //     }, err => this.alert.handle(err));
    }

    refresh() {
        return this.api.get(`guestlists/${this.guestlist.id}`)
            .then(response => {
                this.guestlist = response.data.data;
                return this.store.dispatch('getData');
            }, err => {
                this.alert.handle(err);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/duplicates.js